import React, { useEffect } from 'react';

import collabShirt from '../assets/images/common/LVLCS-x-WMT-thumbnail.png'
import { ReactComponent as twitterIcon } from '../assets/images/icons/twitter-16px.svg'
import UtilityItem from '../components/utility-component';
import CongratsOrderItem from '../components/congrats-order-item';
import ButtonOutline from '../components/button-outline';
import ButtonFilled from '../components/button-filled';
import { useDispatch, useSelector } from 'react-redux';
import { resetOrderInfo, selectOrderInfo } from '../redux/orderInfoSlice';
import { UserDeadline } from '../constants/localStorageKeys';

const CongratsPage = ({ handleGoHomepage }) => {
  const savedShippingInfo = useSelector(selectOrderInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    localStorage.removeItem(UserDeadline);
  })

  const goHomePage = () => {
    resetOrderInfo();
    handleGoHomepage();
  }

  const shareOnX = () => {
    const tweetText = "Secured the bag 🔥 Just got my LVLCS x World Mobile Football iRL Jersey! Get yours at ";
    const tweetUrl = "https://www.lvlcs.io/wmt-collaboration";
    // const tweetImageUrl = `https://static.wixstatic.com/media/71f9a6_109a9debe138478e847ed810abd922f5~mv2.png/v1/fill/w_239,h_238,fp_0.45_0.11,q_85,usm_0.66_1.00_0.01,enc_auto/LVLCS_WMT_Thumbnail.png`;

    const encodedText = encodeURIComponent(tweetText);
    const encodedUrl = encodeURIComponent(tweetUrl);
    // const encodedImageUrl = encodeURIComponent(tweetImageUrl);

    const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;

    window.open(twitterShareUrl, '_blank', 'width=550,height=420');

  }

  return (
    <section className='page-container'>
      <div className='order-page congrats-stage'>
        <h2>CONGRATS, BIG WIN! 🎉</h2>

        <div className='center-items-horizontal congrats-content'>
          <div className='order-main-item'>
            <p>LVLCS x World Token Mobile Football Jersey</p>
            <img src={collabShirt} alt='collab-shirt'/>
          </div>

          <div className='order-summary'>
            <p>Congratulations on your purchase. Your NFT(s) should be in your wallet and your jersey will be shipped out in Q1 2024. We will notify you through email updates.</p>

            <h5>WHAT YOU WILL RECIEVE:</h5>

            <CongratsOrderItem itemQuantity='QUANTITY' itemDesc='PRODUCT DESCRIPTION' itemSize='SIZE' isHeader={true}/>

            <hr/>

            <div className='items-block'>
              {Object.values(Object.groupBy(savedShippingInfo.sizes,  (x) => x )).map((group) => (
                  <CongratsOrderItem itemQuantity={group.length} itemDesc='LVLCS x World Mobile Token Football Jersey iRL' itemSize={group[0]}/>
              ))}  
              <CongratsOrderItem itemQuantity={savedShippingInfo.sizes.length} itemDesc='LVLCS x World Mobile Token Football Jersey NFT'/>
              {/* <CongratsOrderItem itemQuantity='5,000' itemDesc='Pointz Tokens'/> */}
            </div>
          </div>

          <div className='utilities-block'>
            <h5>UTILITIES INCLUDED:</h5>
            <div className='utilities-row'>
              <UtilityItem label='NFT'/>
              <UtilityItem label='IRL'/>
              <UtilityItem label='NFT-C'/>
              <UtilityItem label='META'/>
              {/* <UtilityItem label='POINTZ'/> */}
            </div>
          </div>

          <div className='navigation-block-buttons'>
            <ButtonOutline label='SHARE ON TWITTER' palette='secondary' size='regular' customStyles={{width: 290}} icon={twitterIcon} onClick={shareOnX}/>
            <ButtonFilled label='BACK TO HOMEPAGE' palette='primary' size='regular' customStyles={{width: 290}} onClick={goHomePage}/>
          </div>
        </div>
      </div>
    </section>
  );
};
  
export default CongratsPage;